<template>
  <div class="container">
    <div class="searchBox">
      <van-search
        v-model="keyword"
        shape="round"
        background="transparent"
        placeholder="关键词搜索"
        @search="searchHandle"
      />
    </div>
    <div class="title">大咖推荐</div>
    <div class="scrollView">
      <div class="scrollItem" v-for="(item, index) in mlist" :key="index">
        <van-image
          fit="cover"
          :src="item.Photo"
          round
          error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
          @click="toHomePage(item.MemberId)"
        ></van-image>
        <div class="name overFlowTwo">{{ item.NickName }}</div>
        <div
          v-if="item.IsFollow"
          class="btn follwBtn"
          @click="followChange(item.MemberId, index)"
        >
          <span class="iconfont icon-gou"></span>
          <span>已关注</span>
        </div>
        <div
          v-else
          class="btn unfollwBtn"
          @click="followChange(item.MemberId, index)"
        >
          <span class="iconfont icon-add"></span>
          <span>关注</span>
        </div>
      </div>
    </div>
    <div class="postList">
      <div class="postTitle">大咖动态</div>
      <van-notice-bar
        v-if="operateList[0].length > 0"
        scrollable
        text=""
        background="#ffffff"
        speed="40"
      >
        <div class="tb_ul">
          <div
            class="tb_item"
            v-for="(item, index) in operateList[0]"
            :key="index"
          >
            <van-image
              fit="cover"
              :src="item.HeadlineLogo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            ></van-image>
            <span>{{ item.Headline }}{{ item.Desc }}</span>
          </div>
        </div>
      </van-notice-bar>
      <van-notice-bar
        v-if="operateList[1].length > 0"
        scrollable
        text=""
        background="#ffffff"
        speed="40"
      >
        <div class="tb_ul">
          <div
            class="tb_item"
            v-for="(item, index) in operateList[1]"
            :key="index"
          >
            <van-image
              fit="cover"
              :src="item.HeadlineLogo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            ></van-image>
            <span>{{ item.Headline }}{{ item.Desc }}</span>
          </div>
        </div>
      </van-notice-bar>

      <!-- 轮播图 -->
      <div class="postItemBox">
        <van-swipe
          style="width: 100%; height: 100%"
          @change="swiperBrandChange"
          duration="1000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, index) in postlist" :key="index">
            <div
              class="postItem"
              v-for="(inner, innerIndex) in item.children"
              :key="innerIndex"
              @click="toHomePage(inner.MemberId)"
            >
              <div class="postContent">
                <van-image
                  round
                  fit="cover"
                  :src="inner.HeadlineLogo"
                  error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                ></van-image>
                <div>
                  <div class="postItemName">{{ inner.Headline }}</div>
                  <div class="postTime">{{ inner.Time }}发布了动态</div>
                </div>
              </div>
              <div class="rightIcon">
                <span class="iconfont icon-right"></span>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <!--重置小圆点的样式 -->
        <div class="dots">
          <div v-for="(item, index) in postlist" :key="index">
            <div
              class="dot"
              :class="index == postCurrent ? 'active' : ''"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 切换列表 -->
    <div class="tabBox">
      <div
        class="tabItem"
        :class="type == 1 ? 'active' : 'noActive'"
        @click="tabClcik(1)"
      >
        行业大咖
      </div>
      <div
        class="tabItem"
        :class="type == 2 ? 'active' : 'noActive'"
        @click="tabClcik(2)"
      >
        品牌大咖
      </div>
    </div>

    <div class="listBox">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <dynamic-list :list="list"></dynamic-list>
      </van-list>
      <div class="noDataBox" v-if="list.length == 0">
        <span class="iconfont icon-kong"></span>
        <div>什么也没有！</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Search,
  Image,
  Swipe,
  SwipeItem,
  List,
  Col,
  Row,
  Icon,
  NoticeBar,
} from "vant";
import {
  recMemberList,
  recMemberPostMsg,
  recMemberListByPost,
  followMember,
  unFollowMember,
  recMemberOperationList,
} from "@/api/index";
import DynamicList from "@/components/dynamicList.vue";
export default {
  name: "industryGuru",
  components: {
    "van-search": Search,
    "van-image": Image,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-list": List,
    "van-col": Col,
    "van-row": Row,
    "van-icon": Icon,
    "van-notice-bar": NoticeBar,
    DynamicList,
  },
  data() {
    return {
      keyword: "",
      mlist: [],
      operateList: [[], []], //动态列表
      postlist: [],
      postCurrent: 0,

      type: 1,
      list: [],
      pageIndex: 1,
      total: 0,
      finished: false,
      error: false,
      loading: false,
    };
  },
  methods: {
    //跳个人主页
    toHomePage(id) {
      this.$router.push({
        path: "/homePage",
        query: { mid: id },
      });
    },

    //跳转搜索页
    searchHandle() {
      this.$router.push({
        path: "/guruSearch",
        query: { keyword: this.keyword },
      });
    },

    //切换
    tabClcik(n) {
      this.list = [];
      this.type = n;
      this.pageIndex = 1;
      this.getListHandle();
    },

    //获取推荐
    getRecommand() {
      recMemberList().then((res) => {
        this.mlist = res.Data.List;
      });
    },

    //轮播切换-自制定点
    swiperBrandChange(index) {
      this.postCurrent = index;
    },

    //大咖操作动态
    getOperateList() {
      var that = this;
      recMemberOperationList().then((res) => {
        var list = res.Data;
        if (list.length <= 15) {
          that.operateList[0] = res.Data;
          that.operateList[1] = [];
        } else {
          var half = Math.ceil(list.length / 2);
          var firstHalf = list.splice(0, half);
          var secondHalf = list.splice(-half);
          that.operateList[0] = firstHalf;
          that.operateList[1] = secondHalf;
        }
      });
    },

    //获取大咖动态
    getPostList() {
      var that = this;
      recMemberPostMsg().then((res) => {
        that.postlist = that.listCheckHandle(res.Data.List);
      });
    },

    //大咖动态数据处理
    listCheckHandle(list) {
      var length = list.length;
      var num = Math.ceil(length / 3);
      var newList = [];
      for (var i = 0; i < num; i++) {
        var obj = {};
        obj.children = [];
        list.forEach(function (item, index) {
          var data = {};
          data.HeadlineLogo = item.HeadlineLogo;
          data.Headline = item.Headline;
          data.Time = item.Time;
          data.PostId = item.PostId;
          data.MemberId = item.MemberId;
          if (index < 3) {
            obj.children.push(data);
          }
        });
        newList.push(obj);
        list.splice(0, 3);
      }
      return newList;
    },

    //获取动态列表
    getListHandle() {
      var that = this;
      var data = {
        Type: that.type,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      recMemberListByPost(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    // 头条号操作
    followChange(id, index) {
      var list = this.mlist;
      if (list[index].IsFollow) {
        unFollowMember({
          MemberId: id,
        }).then((res) => {
          list[index].IsFollow = false;
        });
      } else {
        followMember({
          MemberId: id,
        }).then((res) => {
          list[index].IsFollow = true;
        });
      }
      this.mlist = list;
    },
  },
  created() {
    this.getPostList();
  },
  mounted() {
    this.getRecommand();
    this.getOperateList();
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f5f5;
  .title {
    color: #333;
    font-size: 18px;
    margin: 19px 20px 18px 13px;
  }
  .scrollView {
    overflow-x: auto;
    display: flex;
    margin-bottom: 18px;

    .scrollItem {
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 15px 17px 15px;
      margin-right: 8px;
      vertical-align: top;
      &:first-child {
        margin-left: 13px;
      }

      &:last-child {
        margin-right: 13px !important;
      }

      .van-image {
        display: block;
        width: 50px;
        height: 50px;
      }

      .name {
        height: 40px;
        line-height: 20px;
        text-align: center;
        width: 93px;
        color: #4d5c87;
        font-size: 12px;
        margin: 15px 0px 30px 0px;
      }
    }
  }
  .postList {
    margin-bottom: 11px;
    background-color: #fff;

    .postTitle {
      padding: 27px 20px 25px 13px;
      font-size: 18px;
    }
    /deep/.van-notice-bar__wrap {
      height: 30px;
    }
    /deep/.van-notice-bar__content {
      min-width: 100.1% !important;
    }
    .tb_ul {
      display: flex;
      align-items: center;
      .tb_item {
        display: flex;
        align-items: center;
        color: #333;
        font-size: 11px;
        border: 1px solid #dddddd;
        border-radius: 13px;
        height: 27px;
        line-height: 27px;
        background: #eee;
        box-sizing: border-box;
        padding: 0 11px 0px 2px;
        margin-right: 12px;
        span {
          margin-left: 6px;
        }
      }
      .van-image {
        display: block;
        width: 25px;
        height: 25px;
      }
    }

    .postItemBox {
      .postItem {
        height: 68px;
        border-bottom: 1px solid #ddd;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0px 12px;
        .van-image {
          display: block;
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }
        .postContent {
          display: flex;
          align-items: center;

          .postItemName {
            color: #4d5c87;
            font-size: 13px;
          }

          .postTime {
            font-size: 10px;
            color: #999;
            margin-top: 5px;
          }
        }

        .rightIcon {
          width: 15px;
          height: 15px;
          border: 1px solid #999;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;

          .iconfont {
            color: #999;
            font-size: 10px;
          }
        }
      }
      .dots {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 11px 0px 32px 0px;

        .dot {
          width: 7px;
          height: 7px;
          border: 1px solid #d62f2f;
          border-radius: 50%;
          margin-right: 4px;
        }

        .active {
          background: #d62f2f;
        }
      }
    }
  }
  .tabBox {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333;
    height: 57px;
    background-color: #fff;
    .tabItem {
      position: relative;
      text-align: center;
      width: 175px;
    }

    .active {
      font-weight: bold;
      color: #d62f2f;

      &::before {
        content: "";
        display: block;
        position: absolute;
        bottom: -20px;
        left: 0px;
        width: 100%;
        height: 5px;
        background-color: #d62f2f;
      }
    }

    .noActive {
      &::before {
        content: "";
        display: block;
        position: absolute;
        bottom: -20px;
        left: 0px;
        width: 100%;
        height: 5px;
        background-color: #ddd;
      }
    }
  }
  .btn {
    width: 75px;
    height: 25px;
    line-height: 25px;
    border-radius: 13px;
    font-size: 11px;
    text-align: center;

    .iconfont {
      font-size: 12px;
      margin-right: 6px;
    }
  }
  .unfollwBtn {
    color: #fff;
    background: #d62f2f;
  }
  .follwBtn {
    color: #d62f2f;
    border: 1px solid #ccc;
  }
}
</style>